import { Injectable, NgZone } from '@angular/core';
import ResizeObserver from 'resize-observer-polyfill';

@Injectable({
    providedIn: 'root'
})
export class ResizeObserverService {
    constructor(
        private readonly ngZone: NgZone
    ) {
    }

    public createAndObserve(callback: ResizeObserverCallback, element: HTMLElement): ResizeObserver {
        const observer = new ResizeObserver(callback);

        this.ngZone.runOutsideAngular(() => {
            observer.observe(element);
        });

        return observer;
    }
}
